import { useEffect, useState } from "react";
export var useGetSummary = function () {
    var _a = useState(null), summary = _a[0], setSummary = _a[1];
    useEffect(function () {
        try {
            var stored = localStorage.getItem("summary");
            var parsed = stored ? JSON.parse(stored) : null;
            setSummary(parsed);
        }
        catch (_) {
            setSummary(null);
        }
    }, []);
    return summary;
};
